module.exports = __webpack_public_path__ + "static/media/shape2_4.fe729752.obj";